import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes, FaUser, FaSignOutAlt, FaCog, FaKey } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { changePassword } from '../services/api';
import ChangePasswordModal from './ChangePasswordModal';
import LanguageSwitcher from './LanguageSwitcher';
import { useT } from '../i18n/LanguageContext';
import './Navbar.css';

const T = {
    en: {
        home: 'Home', about: 'About', store: 'Store', training: 'Training',
        warehousing: 'Warehousing', transit: 'Transit', contact: 'Contact',
        admin: 'Admin', provider: 'Provider', changePassword: 'Change Password',
        changePasswordTitle: 'Change password', logout: 'Logout', login: 'Login',
    },
    fr: {
        home: 'Accueil', about: 'À propos', store: 'Boutique', training: 'Formations',
        warehousing: 'Entreposage', transit: 'Transit', contact: 'Contact',
        admin: 'Admin', provider: 'Fournisseur', changePassword: 'Changer le mot de passe',
        changePasswordTitle: 'Changer le mot de passe', logout: 'Déconnexion', login: 'Connexion',
    },
};

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const t = useT(T);

    const openPasswordModal = () => {
        setShowPasswordModal(true);
        setMenuOpen(false);
    };

    const links = [
        { path: '/', label: t.home },
        { path: '/about', label: t.about },
        { path: '/products', label: t.store },
        { path: '/training', label: t.training },
        { path: '/warehousing', label: t.warehousing },
        { path: '/transit', label: t.transit },
        { path: '/contact', label: t.contact },
    ];

    const handleLogout = () => {
        logout();
        setMenuOpen(false);
        navigate('/');
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo">
                    <img src="/logo.png" alt="ElecSolution" className="navbar-logo-img" />
                </Link>
                <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </div>
                <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
                    {links.map((link) => (
                        <li key={link.path} className="nav-item">
                            <Link
                                to={link.path}
                                className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
                                onClick={() => setMenuOpen(false)}
                            >
                                {link.label}
                            </Link>
                        </li>
                    ))}

                    <li className="nav-item nav-lang">
                        <LanguageSwitcher />
                    </li>

                    <li className="nav-item nav-auth nav_mobile">
                        {user ? (
                            <div className="nav-user-section">
                                <div className='user-holder holder2'>
                                    <span className="nav-user-name"><FaUser /> {user.name}</span>
                                    {user.role === 'admin' && (
                                        <Link to="/admin" className="nav-admin-link" onClick={() => setMenuOpen(false)}>
                                            <FaCog /> {t.admin}
                                        </Link>
                                    )}
                                    {user.role === 'provider' && (
                                        <Link to="/provider" className="nav-admin-link" onClick={() => setMenuOpen(false)}>
                                            <FaCog /> {t.provider}
                                        </Link>
                                    )}

                                    <button className="nav-change-pw-btn" onClick={openPasswordModal}>
                                        <FaKey /> {t.changePassword}
                                    </button>

                                </div>
                                <button className="nav-logout-btn" onClick={handleLogout}>
                                    <FaSignOutAlt /> {t.logout}
                                </button>
                            </div>
                        ) : (
                            <div className="nav-auth-links">
                                <Link
                                    to="/login"
                                    className={`nav-link auth-link ${location.pathname === '/login' ? 'active' : ''}`}
                                    onClick={() => setMenuOpen(false)}
                                >
                                    {t.login}
                                </Link>
                            </div>
                        )}
                    </li>
                </ul>

                <div className="nav-item nav-auth nav_desk">
                    {user ? (
                        <div className="nav-user-section">
                            <div className='user-holder holder2'>
                                <span className="nav-user-name"><FaUser /> {user.name}</span>
                                {user.role === 'admin' && (
                                    <Link to="/admin" className="nav-admin-link" onClick={() => setMenuOpen(false)}>
                                        <FaCog /> {t.admin}
                                    </Link>
                                )}
                                {user.role === 'provider' && (
                                    <Link to="/provider" className="nav-admin-link" onClick={() => setMenuOpen(false)}>
                                        <FaCog /> {t.provider}
                                    </Link>
                                )}

                                <button className="nav-change-pw-btn" onClick={openPasswordModal} title={t.changePasswordTitle}>
                                    <FaKey />
                                </button>
                            </div>

                            <button className="nav-logout-btn" onClick={handleLogout}>
                                <FaSignOutAlt /> {t.logout}
                            </button>
                        </div>
                    ) : (
                        <div className="nav-auth-links">
                            <Link
                                to="/login"
                                className={`nav-link auth-link ${location.pathname === '/login' ? 'active' : ''}`}
                                onClick={() => setMenuOpen(false)}
                            >
                                Login
                            </Link>
                        </div>
                    )}
                </div>
            </div>

            {showPasswordModal && (
                <ChangePasswordModal
                    onClose={() => setShowPasswordModal(false)}
                    changePassword={changePassword}
                />
            )}
        </nav>
    );
}

export default Navbar;
